import { render, staticRenderFns } from "./PrintingInstructions.vue?vue&type=template&id=8190b670&scoped=true&"
import script from "./PrintingInstructions.vue?vue&type=script&lang=js&"
export * from "./PrintingInstructions.vue?vue&type=script&lang=js&"
import style0 from "./PrintingInstructions.vue?vue&type=style&index=0&id=8190b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8190b670",
  null
  
)

export default component.exports